import {CurrencyHelper} from "../../utils/CurrencyHelper";

export const COST_METRIC_NAME = 'Cost';
export const CLICKS_METRIC_NAME = 'Clicks';
export const CONVERSIONS_METRIC_NAME = 'Conversions';
export const IMPRESSIONS_METRIC_NAME = 'Impressions';
export const CPC_METRIC_NAME = 'CPC';
export const CTR_METRIC_NAME = 'CTR';
export const CPM_METRIC_NAME = 'CPM';
export const CPA_METRIC_NAME = 'CPA';
export const PURCHASES_VALUE_METRIC_NAME = 'Purchase Value';
export const ROAS_METRIC_NAME = 'ROAS';
export const ACOS_METRIC_NAME = 'ACOS';
export const CONVERSION_RATE_METRIC_NAME = 'Conversion Rate';

export const GA4_SESSIONS_METRIC_NAME = "Sessions (GA4)";
export const GA4_ACTIVE_USERS_METRIC_NAME = "Active Users (GA4)";
export const GA4_CONVERSIONS_METRIC_NAME = "Conversions (GA4)";
export const GA4_ECOMMERCE_PURCHASES_METRIC_NAME = "Ecommerce purchases (GA4)";
export const GA4_PURCHASE_REVENUE_METRIC_NAME = "Purchase Revenue (GA4)";
export const GA4_ROAS_METRIC_NAME = "ROAS (GA4)";
export const GA4_ACOS_METRIC_NAME = "ACOS (GA4)";
export const GA4_CPA_METRIC_NAME = "CPA (GA4)";

// Meta (Facebook/Instagram) live-api metrics. Son fetchadas on-demand desde Meta
// Insights en SyncDashboard y cacheadas en LiveApiMetric (no pasan por BigQuery).
export const META_REACH_METRIC_NAME = "Reach (Meta)";
export const META_FREQUENCY_METRIC_NAME = "Frequency (Meta)";
export const META_VIDEO_VIEW_METRIC_NAME = "Meta_Video_view";
export const META_VIDEO_VIEW_3S_METRIC_NAME = "Meta_Video_view_3s";
export const META_VIDEO_VIEW_3S_RATE_METRIC_NAME = "Meta_Video_view_3s_rate";
export const META_IG_NEW_FOLLOWERS_METRIC_NAME = "Meta_IG_new_followers";
export const META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME = "Meta_Cost_per_IG_new_follower";
export const META_IG_PROFILE_VISITS_METRIC_NAME = "Meta_IG_profile_visits";
export const META_POST_REACTION_METRIC_NAME = "Meta_Post_reaction";
export const META_COMMENT_METRIC_NAME = "Meta_Comment";
export const META_CLICK_TO_CALL_METRIC_NAME = "Meta_Click_to_call";
export const META_LIKE_METRIC_NAME = "Meta_Like";
export const META_COST_PER_LIKE_METRIC_NAME = "Meta_Cost_per_like";

export const ECOMMERCE_SESSIONS_METRIC_NAME = "Sessions (Ecommerce)";
export const ECOMMERCE_GROSS_REVENUE_METRIC_NAME = "Gross Revenue (Ecommerce)";
export const ECOMMERCE_ORDERS_METRIC_NAME = "Orders (Ecommerce)";
export const ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME = "Avg Gross Order Value (Ecommerce)";
export const ECOMMERCE_ROAS_METRIC_NAME = "ROAS (Ecommerce)";
export const ECOMMERCE_ACOS_METRIC_NAME = "ACOS (Ecommerce)";
export const ECOMMERCE_CONVERTION_RATE_METRIC_NAME = "Conversion Rate (Ecommerce)";
export const ECOMMERCE_CPA_METRIC_NAME = "CPA (Ecommerce)";

// Métricas que pueden venir vacías porque la API no ofrece datos (ej: TiendaNube no levanta sesiones)
export const METRICS_WITH_POTENTIAL_EMPTY_VALUES = [
    ECOMMERCE_SESSIONS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME
];

// Mapeo de métricas a claves de traducción para mensajes específicos cuando están vacías
export const EMPTY_METRIC_VALUE_TOOLTIP_KEYS = {
    [ECOMMERCE_SESSIONS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ecommerce_sessions',
    [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ecommerce_conversion_rate'
};

export const META_METRICS = [
    META_REACH_METRIC_NAME, META_FREQUENCY_METRIC_NAME, META_VIDEO_VIEW_METRIC_NAME,
    META_VIDEO_VIEW_3S_METRIC_NAME, META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    META_IG_NEW_FOLLOWERS_METRIC_NAME, META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME,
    META_IG_PROFILE_VISITS_METRIC_NAME, META_POST_REACTION_METRIC_NAME,
    META_COMMENT_METRIC_NAME, META_CLICK_TO_CALL_METRIC_NAME,
    META_LIKE_METRIC_NAME, META_COST_PER_LIKE_METRIC_NAME,
];

export const ALL_METRICS = [COST_METRIC_NAME, CLICKS_METRIC_NAME, CONVERSIONS_METRIC_NAME, IMPRESSIONS_METRIC_NAME,
    CPC_METRIC_NAME, CTR_METRIC_NAME, CPM_METRIC_NAME, CPA_METRIC_NAME, PURCHASES_VALUE_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME, CONVERSION_RATE_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME, GA4_ACTIVE_USERS_METRIC_NAME, GA4_CONVERSIONS_METRIC_NAME, GA4_ECOMMERCE_PURCHASES_METRIC_NAME,
    GA4_PURCHASE_REVENUE_METRIC_NAME, GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME, GA4_CPA_METRIC_NAME,
    ECOMMERCE_SESSIONS_METRIC_NAME, ECOMMERCE_GROSS_REVENUE_METRIC_NAME, ECOMMERCE_ORDERS_METRIC_NAME, ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME, ECOMMERCE_ROAS_METRIC_NAME,
    ECOMMERCE_ACOS_METRIC_NAME, ECOMMERCE_CONVERTION_RATE_METRIC_NAME, ECOMMERCE_CPA_METRIC_NAME,
    ...META_METRICS];

export const HAS_ACTIONS_EXTRA_DATA = [CONVERSIONS_METRIC_NAME, CPA_METRIC_NAME, CONVERSION_RATE_METRIC_NAME];

export const METRIC_TYPE_CURRENCY = 'Currency'
export const METRIC_TYPE_INTEGER = 'Integer'
export const METRIC_TYPE_DECIMAL = 'Decimal'

export const PROPERTIES_FOR_METRIC = {
    [COST_METRIC_NAME]: {'Spanish':'Costo', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [CLICKS_METRIC_NAME]: {'Spanish':'Clicks', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [CONVERSIONS_METRIC_NAME]: {'Spanish':'Conversiones', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [IMPRESSIONS_METRIC_NAME]: {'Spanish':'Impresiones', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [CPC_METRIC_NAME]: {'Spanish':'CPC', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [CTR_METRIC_NAME]: {'Spanish':'CTR', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [CPM_METRIC_NAME]: {'Spanish':'CPM', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [CPA_METRIC_NAME]: {'Spanish':'CPA', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [PURCHASES_VALUE_METRIC_NAME]: {'Spanish':'Valor de Compra', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [ROAS_METRIC_NAME]: {'Spanish':'ROAS', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ACOS_METRIC_NAME]: {'Spanish':'ACOS', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [CONVERSION_RATE_METRIC_NAME]: {'Spanish':'Tasa de conversión', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_SESSIONS_METRIC_NAME]: {'Spanish':'Sesiones (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [GA4_ACTIVE_USERS_METRIC_NAME]: {'Spanish':'Usuarios (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [GA4_CONVERSIONS_METRIC_NAME]: {'Spanish':'Conversiones (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_ECOMMERCE_PURCHASES_METRIC_NAME]: {'Spanish':'Transacciones de ecommerce (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_PURCHASE_REVENUE_METRIC_NAME]: {'Spanish':'Ingresos (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [GA4_ROAS_METRIC_NAME]: {'Spanish':'ROAS (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_ACOS_METRIC_NAME]: {'Spanish':'ACOS (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_CPA_METRIC_NAME]: {'Spanish':'CPA (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_SESSIONS_METRIC_NAME]: {'Spanish':'Sesiones (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [ECOMMERCE_GROSS_REVENUE_METRIC_NAME]: {'Spanish':'Ventas Totales (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_ORDERS_METRIC_NAME]: {'Spanish':'Órdenes (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME]: {'Spanish':'Valor promedio de orden (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_ROAS_METRIC_NAME]: {'Spanish':'ROAS (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_ACOS_METRIC_NAME]: {'Spanish':'ACOS (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: {'Spanish':'Tasa de conversión (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_CPA_METRIC_NAME]: {'Spanish':'CPA (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_REACH_METRIC_NAME]: {'Spanish':'Alcance', 'Accumulates': false, 'Type': METRIC_TYPE_INTEGER},
    [META_FREQUENCY_METRIC_NAME]: {'Spanish':'Frecuencia', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [META_VIDEO_VIEW_METRIC_NAME]: {'Spanish':'Reproducciones de video', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_VIDEO_VIEW_3S_METRIC_NAME]: {'Spanish':'Video Views 3 segundos', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_VIDEO_VIEW_3S_RATE_METRIC_NAME]: {'Spanish':'% Video Views 3 segundos', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [META_IG_NEW_FOLLOWERS_METRIC_NAME]: {'Spanish':'Nuevos seguidores de Instagram', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME]: {'Spanish':'Costo por seguidor de Instagram', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_IG_PROFILE_VISITS_METRIC_NAME]: {'Spanish':'Visitas al perfil de Instagram', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_POST_REACTION_METRIC_NAME]: {'Spanish':'Reacciones al post', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COMMENT_METRIC_NAME]: {'Spanish':'Comentarios', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_CLICK_TO_CALL_METRIC_NAME]: {'Spanish':'Llamadas realizadas', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_LIKE_METRIC_NAME]: {'Spanish':'Me gusta de Facebook', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_LIKE_METRIC_NAME]: {'Spanish':'Costo por Me gusta', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY}
}

export const FORMAT_METRIC_VALUE = (metric_name, value) => {
    const type = PROPERTIES_FOR_METRIC[metric_name]["Type"];
    if(type === METRIC_TYPE_CURRENCY)
        return CurrencyHelper.formatNumberToCurrency(value, true);
    else if(type === METRIC_TYPE_INTEGER)
        return value;
    else if(type === METRIC_TYPE_DECIMAL)
        return parseFloat(value).toLocaleString('en-US');

    throw new Error(`Invalid metric type for ${metric_name}`);
};
